import { useState } from "react";
import { Link } from "react-router-dom";

/* -------- UI -------- */
import ProfileMenu from "../../ui/Header/ProfileMenu";
import NotificationDropdown from "../../ui/Header/NotificationDropDown";
import ThemeMode from "../../ui/Header/ThemeMode";
import { logo } from "../../../utils/items";
/* -------- ------- -------- */


/* -------- packages -------- */
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
/* -------- ------- -------- */


export default function Header ({isNavbarOpen, toggleNavbarCallback}) {
    const parameters = useSelector(state => state.Parameters);
    const user = useSelector(state => state.Login.user);
    const { t } = useTranslation();

    const [search, setsearch] = useState(false);
  
    function tToggle() {
      var body = document.body;
      if (window.screen.width <= 998) {
        body.classList.toggle("sidebar-enable");
      } else {
        body.classList.toggle("vertical-collpsed");
        body.classList.toggle("sidebar-enable");
      }
    }

  
    return (
        <header id="page-topbar">
            
          <div className="navbar-header">
{/* ------------------ left area of Header ------------------------ */}            
            <div className="d-flex leftArea">

              <div className="navbar-brand-box"> {/* LOGO Area */}
              {/* -------------- left logo --------------------------------------- */}
                    <Link to="/projects" className="logo logo-dark"> {/* LOGOS DARK MODE */}
                      <span className="logo-sm"> {/* Icon logo dark */}
                        <img src={parameters.logoIconDark} alt="logo" height="22" />
                      </span>

                      <span className="logo-lg"> {/* fullSize logo dark */}
                        <img src={logo} alt="logo" className="logoHeader"/>
                      </span>
                    </Link>
                    
                    <Link to="/projects" className="logo logo-light"> {/* LOGO LIGHT MODE */}
                      <span className="logo-sm"> {/* Icon logo light */}
                        <img src={parameters.logoIconDark} alt="logo" height="22" />
                      </span>

                      <span className="logo-lg"> {/* fillSize logo light */}
                        <img src={logo} alt="logo" className="logoHeader"/>
                      </span>
                    </Link>

              {/* -------------------------------------------------------------------- */}

                    <div className="logo dividerLogo"> 
                      <span className="dividerSpan logo-lg"> </span>
                    </div>

              {/* -------------- right logo --------------------------------------- */}
                    <Link to="/projects" className="logo logo-dark">  {/* LOGOS DARK MODE */}

                      <span className="logo-lg"> {/* fillSize logo light */}
                        <img src={parameters.logoDark} alt="logo" className="logoHeader"/>
                      </span>
                    </Link>
                    <Link to="/projects" className="logo logo-light"> {/* LOGO LIGHT MODE */}

                      <span className="logo-lg"> {/* fillSize logo light */}
                        <img src={parameters.logoDark} alt="logo" className="logoHeader"/>
                      </span>
                    </Link>

              {/* -------------------------------------------------------------------- */}

              <button
                type="button"
                className="btn btn-sm px-3 font-size-16 d-lg-none header-item ms-3"
                data-toggle="collapse"
                onClick={() => {
                  toggleNavbarCallback(!isNavbarOpen);
                }}
                data-target="#topnav-menu-content"
              >
                <i className="fa fa-fw fa-bars" />
            </button>
              </div>

  
            </div>
{/* ------------------ --------------------------- ------------------------ */}     

{/* ------------------ right area of Header ------------------------ */}            

            <div className="d-flex header">

              {
                (user) ? (
                  <>
                    <ThemeMode />
                    <NotificationDropdown />
                    <ProfileMenu />
                  </>
                ) 
                :
                (
                  <Link className="btn btn-primary loginBtn" to={'/login'}>
                    <i className='bx bx-user-circle btnIcon '></i>
                    <p className="loginBtnText">{t('signIn')}</p>
                  </Link>
                )
              }

              
            </div>
{/* ------------------ --------------------------- ------------------------ */}     

          </div>
        </header>
    );
}